import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

export const useAppRoutes = () => {
  const {
    isAuthenticated,
    error,
    isLoading,
    signinRedirect,
    signoutRedirect,
    user,
  } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && !error?.message && !isLoading) {
      signinRedirect().then((res) => {});
    }

    if (isLoading && user?.expired) {
      signoutRedirect().catch((e) => {});
    }
  }, [
    error?.message,
    isAuthenticated,
    isLoading,
    signinRedirect,
    signoutRedirect,
    user?.expired,
  ]);

  return { isAuthenticated };
};
